






















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PlaceHolder extends Vue {
	@Prop({ default: true })
	private placehold!: boolean;

	@Prop({ default: 'light' })
	private theme!: string;

	@Prop({ default: 1 })
	private sectionCount!: number;

	@Prop({ default: 4 })
	private lineCount!: number;

	get sectionArray(): Array<number> {
		return new Array(this.sectionCount);
	}

	get lineArray(): Array<number> {
		return new Array(this.lineCount);
	}
}
